declare namespace $ {

	type $mol_paragraph__title_bog_music_eq_curve_1 = $mol_type_enforce<
		ReturnType< $bog_music_eq_curve['db_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__style_bog_music_eq_curve_2 = $mol_type_enforce<
		({ 
			'color': ReturnType< $bog_music_eq_curve['db_color'] >,
		}) 
		,
		ReturnType< $mol_paragraph['style'] >
	>
	type $mol_view__sub_bog_music_eq_curve_3 = $mol_type_enforce<
		ReturnType< $bog_music_eq_curve['db_list'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_svg__dom_name_bog_music_eq_curve_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_svg['dom_name'] >
	>
	type $mol_svg__attr_bog_music_eq_curve_5 = $mol_type_enforce<
		({ 
			'offset': ReturnType< $bog_music_eq_curve['stop_offset'] >,
			'stop-color': ReturnType< $bog_music_eq_curve['stop_color'] >,
		}) 
		,
		ReturnType< $mol_svg['attr'] >
	>
	type $mol_svg__dom_name_bog_music_eq_curve_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_svg['dom_name'] >
	>
	type $mol_svg__attr_bog_music_eq_curve_7 = $mol_type_enforce<
		({ 
			'id': ReturnType< $bog_music_eq_curve['gradient_id'] >,
			'x1': string,
			'x2': string,
			'y1': string,
			'y2': string,
		}) 
		,
		ReturnType< $mol_svg['attr'] >
	>
	type $mol_svg__sub_bog_music_eq_curve_8 = $mol_type_enforce<
		ReturnType< $bog_music_eq_curve['stop_list'] >
		,
		ReturnType< $mol_svg['sub'] >
	>
	type $mol_svg__dom_name_bog_music_eq_curve_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_svg['dom_name'] >
	>
	type $mol_svg__sub_bog_music_eq_curve_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_svg['sub'] >
	>
	type $mol_svg_line__from_x_bog_music_eq_curve_11 = $mol_type_enforce<
		ReturnType< $bog_music_eq_curve['zero_x1'] >
		,
		ReturnType< $mol_svg_line['from_x'] >
	>
	type $mol_svg_line__from_y_bog_music_eq_curve_12 = $mol_type_enforce<
		ReturnType< $bog_music_eq_curve['zero_y'] >
		,
		ReturnType< $mol_svg_line['from_y'] >
	>
	type $mol_svg_line__to_x_bog_music_eq_curve_13 = $mol_type_enforce<
		ReturnType< $bog_music_eq_curve['zero_x2'] >
		,
		ReturnType< $mol_svg_line['to_x'] >
	>
	type $mol_svg_line__to_y_bog_music_eq_curve_14 = $mol_type_enforce<
		ReturnType< $bog_music_eq_curve['zero_y'] >
		,
		ReturnType< $mol_svg_line['to_y'] >
	>
	type $mol_svg_path__geometry_bog_music_eq_curve_15 = $mol_type_enforce<
		ReturnType< $bog_music_eq_curve['curve_geometry'] >
		,
		ReturnType< $mol_svg_path['geometry'] >
	>
	type $mol_svg_path__attr_bog_music_eq_curve_16 = $mol_type_enforce<
		({ 
			'stroke': ReturnType< $bog_music_eq_curve['curve_stroke'] >,
		})  & ReturnType< $mol_svg_path['attr'] >
		,
		ReturnType< $mol_svg_path['attr'] >
	>
	type $mol_svg_circle__radius_bog_music_eq_curve_17 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_svg_circle['radius'] >
	>
	type $mol_svg_circle__pos_x_bog_music_eq_curve_18 = $mol_type_enforce<
		ReturnType< $bog_music_eq_curve['dot_x'] >
		,
		ReturnType< $mol_svg_circle['pos_x'] >
	>
	type $mol_svg_circle__pos_y_bog_music_eq_curve_19 = $mol_type_enforce<
		ReturnType< $bog_music_eq_curve['dot_y'] >
		,
		ReturnType< $mol_svg_circle['pos_y'] >
	>
	type $mol_svg_circle__attr_bog_music_eq_curve_20 = $mol_type_enforce<
		({ 
			'stroke': ReturnType< $bog_music_eq_curve['dot_color'] >,
		})  & ReturnType< $mol_svg_circle['attr'] >
		,
		ReturnType< $mol_svg_circle['attr'] >
	>
	type $mol_svg_group__sub_bog_music_eq_curve_21 = $mol_type_enforce<
		ReturnType< $bog_music_eq_curve['dot_list'] >
		,
		ReturnType< $mol_svg_group['sub'] >
	>
	type $mol_svg_root__view_box_bog_music_eq_curve_22 = $mol_type_enforce<
		ReturnType< $bog_music_eq_curve['view_box'] >
		,
		ReturnType< $mol_svg_root['view_box'] >
	>
	type $mol_svg_root__aspect_bog_music_eq_curve_23 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_svg_root['aspect'] >
	>
	type $mol_svg_root__event_bog_music_eq_curve_24 = $mol_type_enforce<
		({ 
			pointerdown( next?: ReturnType< $bog_music_eq_curve['pointer_down'] > ): ReturnType< $bog_music_eq_curve['pointer_down'] >,
			pointermove( next?: ReturnType< $bog_music_eq_curve['pointer_move'] > ): ReturnType< $bog_music_eq_curve['pointer_move'] >,
			pointerup( next?: ReturnType< $bog_music_eq_curve['pointer_up'] > ): ReturnType< $bog_music_eq_curve['pointer_up'] >,
			pointercancel( next?: ReturnType< $bog_music_eq_curve['pointer_up'] > ): ReturnType< $bog_music_eq_curve['pointer_up'] >,
		}) 
		,
		ReturnType< $mol_svg_root['event'] >
	>
	type $mol_svg_root__sub_bog_music_eq_curve_25 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_svg_root['sub'] >
	>
	type $mol_paragraph__title_bog_music_eq_curve_26 = $mol_type_enforce<
		ReturnType< $bog_music_eq_curve['freq_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_bog_music_eq_curve_27 = $mol_type_enforce<
		ReturnType< $bog_music_eq_curve['freq_list'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_music_eq_curve extends $mol_view {
		db_text( id: any): string
		db_color( id: any): string
		Db( id: any): $mol_paragraph
		db_list( ): readonly(any)[]
		Db_row( ): $mol_view
		view_box( ): string
		gradient_id( ): string
		stop_offset( id: any): string
		stop_color( id: any): string
		Stop( id: any): $mol_svg
		stop_list( ): readonly(any)[]
		Gradient( ): $mol_svg
		Defs( ): $mol_svg
		zero_x1( ): string
		zero_y( ): string
		zero_x2( ): string
		Zero( ): $mol_svg_line
		curve_geometry( ): string
		curve_stroke( ): string
		Curve( ): $mol_svg_path
		dot_x( id: any): string
		dot_y( id: any): string
		dot_color( id: any): string
		Dot( id: any): $mol_svg_circle
		dot_list( ): readonly(any)[]
		Dots( ): $mol_svg_group
		Plot( ): $mol_svg_root
		freq_text( id: any): string
		Freq( id: any): $mol_paragraph
		freq_list( ): readonly(any)[]
		Freq_row( ): $mol_view
		gains( ): readonly(number)[]
		pointer_down( next?: any ): any
		pointer_move( next?: any ): any
		pointer_up( next?: any ): any
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=curve.view.tree.d.ts.map